import {
  TaskDomain as TaskDomainEnum,
  TaskPriority as TaskPriorityEnum,
  TaskStatus as TaskStatusEnum,
  TaskSubtype as TaskSubtypeEnum,
} from "@redotech/redo-task-common/task";
import {
  TaskAssigneeType as TaskAssigneeTypeEnum,
  TaskAssignmentStatus as TaskAssignmentStatusEnum,
} from "@redotech/redo-task-common/task-assignment";
import { Schema } from "effect";
import { enumLiterals } from "../../schema/helpers";

export const TaskDomain = Schema.Literal(...enumLiterals(TaskDomainEnum));
export type TaskDomain = typeof TaskDomain.Type;

export const TaskSubtype = Schema.Literal(...enumLiterals(TaskSubtypeEnum));
export type TaskSubtype = typeof TaskSubtype.Type;

export const TaskStatus = Schema.Literal(...enumLiterals(TaskStatusEnum));
export type TaskStatus = typeof TaskStatus.Type;

export const TaskPriority = Schema.Literal(...enumLiterals(TaskPriorityEnum));
export type TaskPriority = typeof TaskPriority.Type;

export const TaskAssignmentType = Schema.Literal(
  ...enumLiterals(TaskAssigneeTypeEnum),
);
export type TaskAssignmentType = typeof TaskAssignmentType.Type;

export const TaskAssignmentStatus = Schema.Literal(
  ...enumLiterals(TaskAssignmentStatusEnum),
);
export type TaskAssignmentStatus = typeof TaskAssignmentStatus.Type;

export const LiveTaskAssignment = Schema.Struct({
  id: Schema.String,
  assigneeType: TaskAssignmentType,
  assignedLegacyUserId: Schema.NullOr(Schema.String),
  assignedRole: Schema.NullOr(Schema.String),
  status: TaskAssignmentStatus,
  assignedAt: Schema.String,
  resolvedAt: Schema.NullOr(Schema.String),
});
export type LiveTaskAssignment = typeof LiveTaskAssignment.Type;

export const LiveTaskUserState = Schema.Struct({
  seenAt: Schema.NullOr(Schema.String),
  dismissedAt: Schema.NullOr(Schema.String),
  claimedAt: Schema.NullOr(Schema.String),
});
export type LiveTaskUserState = typeof LiveTaskUserState.Type;

export const LiveTaskReference = Schema.Struct({
  referenceTable: Schema.String,
  referenceId: Schema.String,
});
export type LiveTaskReference = typeof LiveTaskReference.Type;

export const LiveTask = Schema.Struct({
  id: Schema.String,
  accountId: Schema.String,
  locationId: Schema.NullOr(Schema.String),
  domain: TaskDomain,
  subtype: TaskSubtype,
  status: TaskStatus,
  priority: TaskPriority,
  referenceType: Schema.String,
  referenceId: Schema.String,
  references: Schema.Array(LiveTaskReference),
  createdByLegacyUserId: Schema.NullOr(Schema.String),
  claimedByLegacyUserId: Schema.NullOr(Schema.String),
  completedByLegacyUserId: Schema.NullOr(Schema.String),
  dueAt: Schema.NullOr(Schema.String),
  claimedAt: Schema.NullOr(Schema.String),
  completedAt: Schema.NullOr(Schema.String),
  cancelledAt: Schema.NullOr(Schema.String),
  createdAt: Schema.String,
  updatedAt: Schema.String,
  assignments: Schema.Array(LiveTaskAssignment),
  userState: Schema.NullOr(LiveTaskUserState),
});
export type LiveTask = typeof LiveTask.Type;

export const TaskConnectedNotification = Schema.Struct({
  _tag: Schema.Literal("taskConnected"),
});
export type TaskConnectedNotification = typeof TaskConnectedNotification.Type;

export const TaskHeartbeatNotification = Schema.Struct({
  _tag: Schema.Literal("taskHeartbeat"),
});
export type TaskHeartbeatNotification = typeof TaskHeartbeatNotification.Type;

export const TaskUpsertedNotification = Schema.Struct({
  _tag: Schema.Literal("taskUpserted"),
  task: LiveTask,
});
export type TaskUpsertedNotification = typeof TaskUpsertedNotification.Type;

export const TaskRemovedNotification = Schema.Struct({
  _tag: Schema.Literal("taskRemoved"),
  taskId: Schema.String,
});
export type TaskRemovedNotification = typeof TaskRemovedNotification.Type;

export const TaskRealtimeNotification = Schema.Union(
  TaskConnectedNotification,
  TaskHeartbeatNotification,
  TaskUpsertedNotification,
  TaskRemovedNotification,
);
export type TaskRealtimeNotification = typeof TaskRealtimeNotification.Type;
